import { lazy } from 'react';

const ShareholdersEquityReport = lazy(() =>
  import('../pages/ShareholdersEquityReport'),
);

const shareholdersEquityReportRoute = {
  public: [],
  auth: [
    {
      name: 'shareholders_equity_report',
      path: '/finance-and-accounting/shareholders-equity-report',
      component: ShareholdersEquityReport,
    },
  ],
};

export default shareholdersEquityReportRoute;
